import { isToday } from './index';

export const avatarText = (value) => {
  if (!value) return '';
  const nameArray = value.split(' ');

  return nameArray.map((word) => word.charAt(0).toUpperCase()).join('');
};

// TODO: Try to implement this: https://twitter.com/fireship_dev/status/1565424801216311297
export const kFormatter = (num) => {
  const regex = /\B(?=(\d{3})+(?!\d))/g;

  return Math.abs(num) > 9999
    ? `${Math.sign(num) * +(Math.abs(num) / 1000).toFixed(1)}k`
    : Math.abs(num).toFixed(0).replace(regex, ',');
};

export const formatDate = (
  value,
  formatting = { month: 'short', day: 'numeric', year: 'numeric' },
) => {
  if (!value) return value;

  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value));
};

export const formatDateToMonthShort = (value, toTimeForCurrentDay = true) => {
  const date = new Date(value);
  let formatting = { month: 'short', day: 'numeric' };
  if (toTimeForCurrentDay && isToday(date)) formatting = { hour: 'numeric', minute: 'numeric' };

  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value));
};
export const prefixWithPlus = (value) => (value > 0 ? `+${value}` : value);

// Integer USD cents (e.g. 15090) → dollars Number (150.9). Null/garbage → 0.
export const usdFromCents = (cents) => (Number(cents) || 0) / 100;

// Amazon marketplace `code` (from MV.campaignCountry) → ISO-3166 alpha-2 used by
// src/assets/css/flags.css. Amazon uses "UK"; the flag sprite uses "gb". Add more
// overrides here if a marketplace code ever diverges from its flag key.
export const MARKETPLACE_FLAG_OVERRIDES = { UK: 'gb' };

export const flagCode = (code) => {
  const c = (code || '').toUpperCase();
  return (MARKETPLACE_FLAG_OVERRIDES[c] || c).toLowerCase();
};

// Visible country code. The SP catalog and joins use GB for the United Kingdom;
// the UI shows UK. Flags stay on GB via flagCode (UK → gb).
export const countryCodeLabel = (code) => {
  const c = (code || '').toUpperCase();
  return c === 'GB' ? 'UK' : c;
};
